import React, { useState } from 'react';
import { storeDashboardApi } from '@/services/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export const StoreSettingsTab = ({ store, token, onUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: store.name || '',
    description: store.description || '',
    location: store.location || '',
    contact_email: store.contact_email || '',
    contact_phone: store.contact_phone || ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await storeDashboardApi.updateSettings(formData);
      toast.success('Inställningar sparade');
      onUpdate();
    } catch (error) {
      toast.error('Kunde inte spara inställningar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-md shadow-sm p-6" data-testid="store-settings">
      <h2 className="text-lg font-bold text-[#0F172A] mb-6">Butiksinställningar</h2>
      <form onSubmit={handleSubmit} className="space-y-4 max-w-xl">
        <div>
          <Label htmlFor="name">Butiksnamn</Label>
          <Input id="name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} className="mt-1" />
        </div>
        <div>
          <Label htmlFor="description">Beskrivning</Label>
          <Textarea id="description" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} className="mt-1" rows={3} />
        </div>
        <div>
          <Label htmlFor="location">Adress</Label>
          <Input id="location" value={formData.location} onChange={(e) => setFormData({ ...formData, location: e.target.value })} className="mt-1" />
        </div>
        <div>
          <Label htmlFor="contact_email">Kontakt-e-post</Label>
          <Input id="contact_email" type="email" value={formData.contact_email} onChange={(e) => setFormData({ ...formData, contact_email: e.target.value })} className="mt-1" />
        </div>
        <div>
          <Label htmlFor="contact_phone">Telefon</Label>
          <Input id="contact_phone" value={formData.contact_phone} onChange={(e) => setFormData({ ...formData, contact_phone: e.target.value })} className="mt-1" />
        </div>
        <Button type="submit" disabled={loading} className="bg-[#003B73] hover:bg-[#002a52]">
          {loading && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
          Spara ändringar
        </Button>
      </form>
    </div>
  );
};
